import React, { Component } from "react";

class About extends Component {
    render() {
        return (
            <div className="centercontent footermargin">

                <h1>About Me</h1>

                <div className="descarea">
                    <img id="img" src=".\imgs\avatar_yellow_portrait_small.jpg" alt="avatar icon" style={{margin: "0"}}/>
                </div>

                <div className="aboutme">
                    <div className="descbox" style={{margin: "1vw auto"}}>
                        <p>
                            I'm an ICT Engineering student from Finland, plagued by the urge to learn everything from software and web development to
                            networking and cyber security. I've been interested in computers and IT for basically my entire life.<br></br><br></br>

                            I spend my free time learning about technologies and working on personal projects. The list of things I want to do
                            is ever-growing, and I will never get enough of learning new things.<br></br><br></br>

                            I'm open to new opportunities for getting my tech skills to the next level.<br></br><br></br>

                            Find me on GitHub and LinkedIn:<br></br>
                            <a href="https://github.com/Tturna" target="_blank" rel="noreferrer">GitHub</a><br></br>
                            <a href="https://www.linkedin.com/in/roope-juponaho-1a9199156/" target="_blank" rel="noreferrer">LinkedIn</a>
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}

export default About;